import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

/** TileLayer can re-add Leaflet's attribution control after map init — remove it explicitly. */
export function RemoveAttributionControl() {
  const map = useMap();

  useEffect(() => {
    const removeAttribution = () => {
      if (map.attributionControl) {
        map.removeControl(map.attributionControl);
      }
    };

    removeAttribution();
    map.on('layeradd', removeAttribution);

    return () => {
      map.off('layeradd', removeAttribution);
    };
  }, [map]);

  return null;
}
